<template>
  <div class="hero pd-intro is-home">
    <div class="section">
      <div class="hero-body has-text-centered">
        <h1 class="title pd-font uppercase spacing" style="color: black">
          The team
        </h1>
        <h2
          class="subtitle pd-font uppercase spacing"
          style="font-family: 'Roboto Mono'"
        >
          24/25
        </h2>
        <div class="container">
          <div class="content pd-font">
            <div class="columns is-centered" v-for="(row, i) in team" :key="i">
              <div class="column" v-for="item in row" :key="item.name">
                <Profile :data="item">
                  <img
                    v-if="item.image"
                    class="img is-rounded is-square"
                    :src="require(`@/assets/team/${item.image}`)"
                    slot="image"
                  />
                </Profile>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Profile from "@/components/Profile";
import { team } from "@/constants/team";

export default {
  components: {
    Profile,
  },
  data() {
    return {
      team: team.reduce((all, one, i) => {
        const ch = Math.floor(i / 4);
        all[ch] = [].concat(all[ch] || [], one);
        return all;
      }, []),
    };
  },
};
</script>
